import { services, stats } from '@/mocks/services';

export default function ServiceSection() {
  return (
    <section className="w-full py-14 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            全方位数字服务
          </h2>
          <p className="text-sm text-foreground-500 max-w-xl mx-auto">
            从影视到购物，从资讯到旅行，亚洲在线为您提供一站式数字生活解决方案
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6 mb-14">
          {services.map((svc) => (
            <div
              key={svc.id}
              className="group flex gap-4 p-5 md:p-6 rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-200 transition-all duration-200"
            >
              <div className="w-12 h-12 flex-shrink-0 flex items-center justify-center rounded-lg bg-accent-100 text-accent-500 group-hover:bg-accent-500 group-hover:text-white transition-all duration-200">
                <i className={`${svc.icon} text-xl`}></i>
              </div>
              <div>
                <h4 className="text-base font-heading font-semibold text-foreground-900 mb-1.5">
                  {svc.title}
                </h4>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  {svc.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-5 md:gap-8">
          {stats.map((stat, idx) => (
            <div key={idx} className="text-center">
              <div className="text-3xl md:text-4xl font-heading font-bold text-primary-500 mb-2">
                {stat.value}
              </div>
              <div className="text-sm text-foreground-500">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}